// extracted by mini-css-extract-plugin
export default {"list":"vbVw1","add":"BIiPH","addText":"i49ro"};